export const PageTitle = ({ children, right }) => (
  <div className="flex items-center justify-between flex-wrap gap-3 mb-5">
    <h1 className="text-2xl font-extrabold uppercase tracking-tight">{children}</h1>
    {right}
  </div>
);

export const Card = ({ children, className = "", ...rest }) => (
  <div {...rest} className={`bg-white border border-[#E2E2E2] ${className}`}>{children}</div>
);

export const Table = ({ head, children, minWidth = "640px" }) => (
  <Card className="overflow-x-auto">
    <table className="w-full text-sm" style={{ minWidth }}>
      <thead>
        <tr className="text-left text-xs uppercase tracking-wider text-[#6B6B6B] border-b border-[#E2E2E2]">
          {head.map((h, i) => <th key={i} className="p-3">{h}</th>)}
        </tr>
      </thead>
      <tbody>{children}</tbody>
    </table>
  </Card>
);

const BADGE = {
  green: "bg-[#1E9E45] text-white",
  red: "bg-[#D0121A] text-white",
  black: "bg-[#111111] text-white",
  amber: "bg-[#E5A000] text-white",
  gray: "bg-[#E2E2E2] text-[#6B6B6B]",
};

export const Badge = ({ color = "gray", children }) => (
  <span className={`inline-block text-[11px] font-bold px-2 py-0.5 whitespace-nowrap ${BADGE[color]}`}>{children}</span>
);

export const Btn = ({ children, variant = "dark", className = "", ...props }) => (
  <button {...props} className={`text-xs font-bold px-3 py-1.5 transition-colors ${variant === "red" ? "bg-[#D0121A] hover:bg-[#A80D14] text-white" : variant === "outline" ? "border border-[#E2E2E2] hover:border-[#111111]" : "bg-[#111111] hover:bg-[#3A3A3A] text-white"} ${className}`}>{children}</button>
);

export const dt = (iso) => new Date(iso).toLocaleDateString("lv-LV");
